import { makeStyles } from '@material-ui/core/styles';
import React, { useEffect, useState } from "react";

//Text field 

//UnoButton
import { unoTheme } from "../../../../assets/styles/unoTheme";
import UnoButton from '../../../utils/UnoButton';

//Grid
import { TableBody, TableCell, TableHead, TableRow, Typography } from "@material-ui/core";
import MyTable from '../../../utils/MyTable';

//API

//Redux
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';
import allActions from "../../../../actions";

import moment from 'moment';
import { headerSearch } from "../../../../assets/styles/unoTheme";

// Utils
import { SuitabilitiesAPI } from "../../../../API/suitabilities";
import { getColorSuitability } from "../../../../controllers/ClientController";
import SuitabilityQuestionaryModal from "./Modals/SuitabilityQuestionaryModal";

import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import SuitabilityDetailModal from './Modals/SuitabilityDetailModal';
import { checkUserIsRole, roles } from '../../../utils/user';
import currentUser from '../../../../reducers/currentUser';
import MySelect from '../../../utils/MySelect';
import { getSuitabilityOptions } from '../../../utils/suitability';
import { ClientAPI } from '../../../../API/client';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        textAlign: 'left',
    },

    main: {
        padding: theme.spacing(2),
    },

    headerSearch: headerSearch,
    switchs: {

        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',

        '& .MuiTypography-root': {
            marginTop: '-2px',
        }

    },
    progressInput: {
        width: '20px !important',
        height: '20px !important',
    },

    buttonsHeader: {
        display: 'flex',
        alignItems: 'center',
    },

    maginRight2: {
        marginRight: theme.spacing(2),
    },
    input: {
        display: 'none',
    },

    imageSelected: {
        width: '100px',
        borderRadius: '10px',
        float: 'left',
        cursor: 'pointer',
        //border: 'solid 1px ' + unoTheme.mainColor
    },
    selectable: {
        '& input': {

            cursor: 'pointer',
            color: unoTheme.mainColor,
        }
    }

}));

export default function ClientInvestorProfileScreen({
    clientOnScreen, setClientOnScreen, openSuitabilityQuestionaryModal, setOpenSuitabilityQuestionaryModal }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const currentUser = useSelector(state => state.currentUser);

    //form    
    const [submitted, setSubmitted] = useState(false);
    const [suitabilities, setSuitabilities] = useState([]);

    const [suitabilityDetail, setSuitabilityDetail] = useState([]);

    const [inputClientSuitability, setInputClientSuitability] = useState(null);
    const [listSuitabilityOptions,] = useState(getSuitabilityOptions())

    async function loadInfos(clientOnScreen) {

        dispatch(allActions.innerLoadActions.setInnerLoad({
            show: true,
            loadMessage: 'Carregando informações do Perfil do Investidor...'
        }));
        const responseSuitabilityResponses = await SuitabilitiesAPI.getSuitabilitiesByClientId(clientOnScreen.id);
        console.log("responseSuitabilityResponses: ", responseSuitabilityResponses);
        if (responseSuitabilityResponses.success) {
            setSuitabilities(responseSuitabilityResponses.body.rows);
        }
        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));

    }

    const doSaveManualSuitability = async () => {


        const responseActiveQuestionary = await SuitabilitiesAPI.getActiveSuitabilitieQuestionary();
        if (responseActiveQuestionary.success && responseActiveQuestionary.body.rows.length == 1) {

            const r = listSuitabilityOptions[inputClientSuitability];
            const obj = {
                user_id: currentUser.user.id,
                client_id: clientOnScreen.id,
                suitability_questionary_id: responseActiveQuestionary.body.rows[0].id,
                response: "MANUAL_SUITABILITY",
                result: r,
                points: 0,
            }
            const responseSaveSuitability = await SuitabilitiesAPI.saveSuitability(obj);
            const responseUpdateSuitabilty = await ClientAPI.updateClientSuitability(clientOnScreen.id, r);

            if (responseUpdateSuitabilty.success) {

                setClientOnScreen({
                    ...clientOnScreen,
                    suitability: r,
                })
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'success',
                    message: 'Suitability salvo com sucesso!'
                }))
            } else {
                dispatch(allActions.mainAlertActions.setMainAlert({
                    show: true,
                    type: 'error',
                    message: 'Falha ao salvar suitability!'
                }))
            }
        } else {
            dispatch(allActions.mainAlertActions.setMainAlert({
                show: true,
                type: 'error',
                message: 'Falha ao carregar questionário suitability ativo!'
            }))
        }

    }

    const doReportSuitability = (row) => {
        const { response } = row;
        if (response == 'MANUAL_SUITABILITY' || response == 'CHECK_LIFETIME_SUITABILITY') {
            setSuitabilityDetail(row)
        } else {

            console.log("Gerar report");
            dispatch(allActions.reportLoadActions.setReportLoad({
                show: true,
                reportType: 'clientSuitability',
                suitabilityResponses: row,
                selectedClient: clientOnScreen,
                message: 'Gerando PDF...',

            }))
        }
    }


    useEffect(() => {

        dispatch(allActions.innerLoadActions.setInnerLoad({ show: false }));
        if (clientOnScreen && !openSuitabilityQuestionaryModal) {

            loadInfos(clientOnScreen);

        }

    }, [clientOnScreen, openSuitabilityQuestionaryModal]);

    return (
        <div className={classes.root}>

            <div class='defaultScrollWithHeaderContent'>
                <div className={classes.main}>

                    <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                        <div style={{ padding: "24px 36px", backgroundColor: getColorSuitability(clientOnScreen?.suitability ?? "CONSERVADOR"), borderRadius: "5px" }}>
                            <Typography variant="h5" style={{ color: "white" }}>{clientOnScreen?.suitability ?? "CONSERVADOR"}</Typography>
                        </div>

                        {
                            checkUserIsRole(currentUser, [roles.superadmin, roles.admin, roles.advisor]) ?
                                <>
                                    <MySelect
                                        initblank
                                        outerlabel={'SUITABILITY (MANUAL)'}
                                        value={inputClientSuitability}
                                        onChange={(e) => setInputClientSuitability(e.target.value)}
                                        options={listSuitabilityOptions.map((row, index) => (
                                            <option key={'client-suitability-2-' + index} value={index}>{row}</option>
                                        ))}
                                        helperText={"Insira o perfil suitability"}
                                        validator={inputClientSuitability == null && submitted ? true : undefined}
                                    />
                                    <UnoButton
                                        onClick={() => doSaveManualSuitability()}
                                        disabled={inputClientSuitability == null}
                                        color="primary">
                                        {'Salvar'}
                                    </UnoButton>
                                </>
                                : null
                        }

                    </div>

                    <div style={{ height: "calc(100% - 80px)" }}>

                        <MyTable
                            stickyHeader
                            size="small"
                            selectable="true">
                            <colgroup>
                                <col width="15%" />
                                <col width="20%" />
                                {/*<col width="20%" />
                            <col width="15%" />
                            <col width="15%" />
                            <col width="10%" /> */}
                            </colgroup>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left">STATUS</TableCell>
                                    <TableCell align="center">DATA DE AVALIAÇÃO</TableCell>
                                    <TableCell align="left">RESPONSÁVEL</TableCell>
                                    <TableCell align="center">RESULTADO</TableCell>
                                    {/* <TableCell align="center">Ações</TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {suitabilities.map((row, index) => (
                                    <TableRow onClick={() =>
                                        doReportSuitability(row)}>
                                        <TableCell align="left" style={{ color: index == 0 ? unoTheme.greenMoney : unoTheme.redMoney }}>{index == 0 ? "VIGENTE" : "VENCIDO"}</TableCell>
                                        <TableCell align="center">{moment.utc(row.created_date).format("DD/MM/YYYY")}</TableCell>
                                        <TableCell align="left">{row.user_name}</TableCell>
                                        <TableCell align="center" style={{ color: getColorSuitability(row.result) }}>{row.result}</TableCell>
                                        {/* <TableCell align="center">
                                            <PictureAsPdfIcon onClick={() => setSuitabilityDetail(row)} style={{ color: "blue", cursor: "pointer" }} />
                                        </TableCell> */}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </MyTable>
                    </div>
                </div>
            </div>

            <SuitabilityQuestionaryModal
                open={openSuitabilityQuestionaryModal}
                clientOnScreen={clientOnScreen}
                setClientOnScreen={setClientOnScreen}
                handleCloseModal={() => setOpenSuitabilityQuestionaryModal(false)} />

            <SuitabilityDetailModal
                suitability={suitabilityDetail}
                clientOnScreen={clientOnScreen}
                handleCloseModal={() => setSuitabilityDetail(false)} />


        </div>
    );
}
